module.exports = __webpack_public_path__ + "img/guide_img04.0806b10e.jpg";